const axios = require('axios');
import mixin from './mixin';
import { userStore } from './store/userStore.js';

const addPurchaseApp = {
    mixins: [mixin],
    data() {
        return {
            purchaseApi: '',
            userApi: '',
            dataSuccess: 'Success',
            dataPending: 'Pending',
            loading: false,
            state: '',
            interval: null
        }
    },
    methods: {
        async getState() {
            this.loading = true;
            const payResponse = await this.getData(this.purchaseApi);
            if (payResponse && payResponse.status === 200) {
                this.state = payResponse.data.typeAlias;
                this.resolveState();
            } else {
                this.state = 'Error';
            }
            this.loading = false;
        },
        async resolveState() {
            if (this.state === this.dataSuccess) {
                const memberResponse = await this.fetchApiData(this.userApi, '', 'get');
                const member = memberResponse?.data;
                if (memberResponse?.status === 200 && member?.id) {
                    userStore.updateUser(member);
                }
            } else if (this.state === this.dataPending) {
                let self = this;

                if (this.interval == null) {
                    this.interval = setInterval(async () => {
                        self.getState();
                        if (self.state !== self.dataPending) {
                            clearInterval(self.interval);
                        }
                    }, 20000);
                }
            }
        },
        async getData(url) {
            try {
                const response = await axios({
                    method: 'get',
                    url: url,
                    headers: { "Content-Type": "application/json" },
                })
                return response;
            } catch (error) {
                console.log(error);
                this.state = 'Error';
            }
        }
    },
    mounted() {
        if (this.$el.dataset.purchaseapi) this.purchaseApi = this.$el.dataset.purchaseapi;
        if (this.$el.dataset.userapi) this.userApi = this.$el.dataset.userapi;
        if (this.$el.dataset.success) this.dataSuccess = this.$el.dataset.success;
        if (this.$el.dataset.pending) this.dataPending = this.$el.dataset.pending;
        this.getState();
    }
}

export default addPurchaseApp;
